export default "__VITE_ASSET__CEbp4zSd__"